// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
  background-color: #fff !important;
  height: calc(100vh - 10px);
}

.class-dropdown {
  width: 100%;
  max-width: 350px;
}
.class-dropdown ::ng-deep .p-dropdown {
  background-color: #f9f9fb;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 4px 8px;
  transition: all 0.2s ease-in-out;
}
.class-dropdown ::ng-deep .p-dropdown:hover {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.class-dropdown ::ng-deep .p-dropdown.p-focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.class-dropdown ::ng-deep .p-dropdown-label {
  font-size: 14px;
  color: #111827;
  padding: 8px 10px;
  text-transform: capitalize;
}
.class-dropdown ::ng-deep .p-dropdown-trigger {
  color: #6b7280;
  transition: color 0.2s;
}
.class-dropdown ::ng-deep .p-dropdown-trigger:hover {
  color: #1571b9;
}
.class-dropdown ::ng-deep .p-dropdown-panel {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}
.class-dropdown ::ng-deep .p-dropdown-item {
  font-size: 14px;
  padding: 8px 12px;
  color: #111827;
  transition: background-color 0.2s;
  text-align: justify;
  text-transform: capitalize;
}
.class-dropdown ::ng-deep .p-dropdown-item:hover {
  background-color: #e0f2fe;
  color: #1571b9;
}
.class-dropdown ::ng-deep .p-dropdown-item.p-highlight {
  background-color: #1571b9;
  color: #fff;
}
.class-dropdown ::ng-deep .p-dropdown-label.p-placeholder {
  color: #9ca3af;
}

.excelFileUpload-section {
  flex: 1;
  overflow-y: auto;
  /* Custom Thin Scrollbar */
}
.excelFileUpload-section::-webkit-scrollbar {
  width: 6px;
}
.excelFileUpload-section::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.excelFileUpload-section::-webkit-scrollbar-thumb {
  background-color: #9ca3af;
  border-radius: 8px;
}
.excelFileUpload-section::-webkit-scrollbar-thumb:hover {
  background-color: #6b7280;
}
.excelFileUpload-section .elibrary-upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.excelFileUpload-section .elibrary-upload-container .pi {
  font-size: 4rem;
}
.excelFileUpload-section .elibrary-upload-container li {
  text-align: justify;
  padding: 10px;
}
.excelFileUpload-section .elibrary-upload-container .upload-card {
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 2rem 2.5rem;
  width: 100%;
  max-width: 600px;
  transition: all 0.3s ease;
}
.excelFileUpload-section .elibrary-upload-container .upload-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-header h3 {
  font-size: 1.4rem;
  color: #1571b9;
  font-weight: 600;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-header h3 i {
  margin-right: 8px;
  color: #1571b9;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .class-dropdown {
  flex: 1;
  min-width: 100%;
  text-align: center;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .file-upload-section {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 2px dashed #93c5fd;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  flex-direction: column;
  width: 100%;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .file-upload-section:hover {
  background: #eff6ff;
  border-color: #1571b9;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .file-upload-section .upload-icon {
  font-size: 1.8rem;
  color: #1571b9;
  margin-bottom: 0.5rem;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .file-upload-section .upload-text span {
  font-weight: 600;
  color: #1e3a8a;
}
.excelFileUpload-section .elibrary-upload-container .upload-card .upload-controls .file-upload-section .upload-text small {
  display: block;
  font-size: 0.8rem;
  color: #64748b;
}

.document-list-section {
  width: 100%;
  padding: 1rem;
  background: #f9fafb;
}
.document-list-section .document-container {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  height: 75vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.document-list-section .document-container .document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.8rem;
}
.document-list-section .document-container .document-header h4 {
  font-weight: 600;
  font-size: 1.2rem;
  color: #1f2937;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group input {
  display: none;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group .custom-checkbox {
  width: 18px;
  height: 18px;
  border: 2px solid #6b7280;
  border-radius: 4px;
  margin-right: 8px;
  position: relative;
  transition: 0.2s;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group .custom-checkbox::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group input:checked + .custom-checkbox {
  background: #1571b9;
  border-color: #1571b9;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group input:checked + .custom-checkbox::after {
  opacity: 1;
}
.document-list-section .document-container .document-header .selection-bar .checkbox-group .label-text {
  color: #374151;
  font-size: 0.95rem;
}
.document-list-section .document-container .library-tile-view {
  flex: 1;
  overflow-y: auto;
  padding-right: 0.5rem;
  /* Custom Thin Scrollbar */
}
.document-list-section .document-container .library-tile-view::-webkit-scrollbar {
  width: 6px;
}
.document-list-section .document-container .library-tile-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.document-list-section .document-container .library-tile-view::-webkit-scrollbar-thumb {
  background-color: #9ca3af;
  border-radius: 8px;
}
.document-list-section .document-container .library-tile-view::-webkit-scrollbar-thumb:hover {
  background-color: #6b7280;
}
.document-list-section .document-container .library-tile-view .document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .checkbox-overlay {
  position: absolute;
  top: 10px;
  right: 10px;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .checkbox-overlay input {
  display: none;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .checkbox-overlay .custom-checkbox {
  width: 25px;
  height: 25px;
  border: 2px solid #9ca3af;
  border-radius: 4px;
  background: #fff;
  position: relative;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .checkbox-overlay .custom-checkbox::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 7px;
  width: 7px;
  height: 18px;
  border: solid #1571b9;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .checkbox-overlay input:checked + .custom-checkbox::after {
  opacity: 1;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-thumbnail img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-info {
  margin-top: 0.5rem;
  text-align: center;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-info .title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-info .shared-by {
  font-size: 0.85rem;
  color: #6b7280;
  margin: 2px 0;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-info .views {
  font-size: 0.8rem;
  color: #9ca3af;
}
.document-list-section .document-container .library-tile-view .document-grid .document-card .document-footer {
  text-align: center;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.5rem;
}
.document-list-section .document-container .empty-state {
  text-align: center;
  color: #6b7280;
  padding: 2rem 0;
}
.document-list-section .document-container .loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}
.document-list-section .document-container .loading-state .spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #d1d5db;
  border-top: 3px solid #1571b9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

/* Spinner Animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.sheet-form-list .sheet-form-container {
  background: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}
.sheet-form-list .sheet-form-container:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.sheet-form-list .sheet-list {
  margin-bottom: 2rem;
}
.sheet-form-list .sheet-item {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  transition: all 0.2s ease;
}
.sheet-form-list .sheet-item:hover {
  background: #f5f9ff;
  border-color: #cce0ff;
}
.sheet-form-list .sheet-item .field {
  margin-bottom: 1rem;
}
.sheet-form-list .sheet-item .label {
  font-weight: 600;
  color: #333;
}
.sheet-form-list .sheet-item .label .required {
  color: #ff3860;
}
.sheet-form-list .sheet-item .input,
.sheet-form-list .sheet-item .select select {
  border-radius: 6px;
  border-color: #ddd;
}
.sheet-form-list .sheet-item .input:focus,
.sheet-form-list .sheet-item .select select:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);
}
.sheet-form-list .sheet-item .remove-btn-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 80%;
}
.sheet-form-list .sheet-item .remove-btn {
  font-size: 0.9rem;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.sheet-form-list .sheet-item .remove-btn i {
  margin-right: 6px;
}
.sheet-form-list .sheet-item .remove-btn:hover {
  background-color: #ffe6e6;
  color: #d32f2f;
}
.sheet-form-list .form-footer {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
.sheet-form-list .form-footer .submit-btn {
  border-radius: 8px;
  font-weight: 600;
  padding: 0.75rem 2rem;
  background-color: #1571b9;
  color: #fff;
  transition: all 0.3s ease;
}
.sheet-form-list .form-footer .submit-btn i {
  margin-right: 8px;
  color: #fff !important;
}
.sheet-form-list .form-footer .submit-btn:hover {
  background-color: #1571b9;
  transform: translateY(-1px);
}

.sheet-form-list {
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 16px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}
.sheet-form-list .data-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.sheet-form-list .sheet-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
}
.sheet-form-list .sheet-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.sheet-form-list .sheet-card .sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  background: linear-gradient(135deg, #1571b9, #00a3ff);
  color: #fff;
  cursor: pointer;
}
.sheet-form-list .sheet-card .sheet-header .sheet-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.sheet-form-list .sheet-card .sheet-header .sheet-title .icon {
  font-size: 1.2rem;
}
.sheet-form-list .sheet-card .sheet-header .sheet-title .sheet-name {
  font-weight: 600;
  font-size: 1.05rem;
  text-transform: capitalize;
}
.sheet-form-list .sheet-card .sheet-header .sheet-actions .icon-toggle {
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.sheet-form-list .sheet-card .sheet-header .sheet-actions .icon-toggle.up {
  display: none;
}
.sheet-form-list .sheet-card .sheet-header.active .icon-toggle.down {
  display: none;
}
.sheet-form-list .sheet-card .sheet-header.active .icon-toggle.up {
  display: inline;
}
.sheet-form-list .sheet-card .sheet-body {
  padding: 1rem 1.5rem;
  background: #fafafa;
  border-top: 1px solid #e5e5e5;
}
.sheet-form-list .sheet-card .sheet-body .qa-item {
  margin-bottom: 0.8rem;
  padding: 0.8rem;
  border-radius: 8px;
  background: #ffffff;
  transition: background 0.2s ease;
}
.sheet-form-list .sheet-card .sheet-body .qa-item.has-question:hover {
  background: #f0f8ff;
}
.sheet-form-list .sheet-card .sheet-body .qa-item .question {
  font-weight: 600;
  color: #333;
}
.sheet-form-list .sheet-card .sheet-body .qa-item .answer {
  color: #555;
  margin-top: 0.3rem;
}
.sheet-form-list .no-data {
  text-align: center;
  color: #777;
  padding: 2rem;
}
.sheet-form-list .no-data i {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}
.sheet-form-list .action-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}
.sheet-form-list .action-buttons .btn {
  border: none;
  border-radius: 8px;
  padding: 0.6rem 1.2rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  transition: background 0.3s ease, transform 0.2s ease;
}
.sheet-form-list .action-buttons .btn-close {
  background: #e0e0e0;
  color: #333;
  width: 60px;
  padding: 14px;
}
.sheet-form-list .action-buttons .btn-close:hover {
  background: #d6d6d6;
  transform: translateY(-2px);
}
.sheet-form-list .action-buttons .btn-download {
  background: linear-gradient(135deg, #1571b9, rgba(21, 114, 185, 0.8509803922));
  color: #fff;
}
.sheet-form-list .action-buttons .btn-download i {
  color: #fff !important;
}
.sheet-form-list .action-buttons .btn-download:hover {
  background: linear-gradient(135deg, #1571b9, rgba(21, 114, 185, 0.8509803922));
  transform: translateY(-2px);
}

::ng-deep .file-cta {
  background-color: #fff !important;
}

.history-toggle-wrapper {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 100;
}
.history-toggle-wrapper .btn-history-toggle {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1571b9, #00a3ff);
  color: #fff;
  border: none;
  border-radius: 50%;
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.3);
  transition: all 0.3s ease;
  z-index: 100;
}
.history-toggle-wrapper .btn-history-toggle i {
  font-size: 1.2rem;
}
.history-toggle-wrapper .btn-history-toggle:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(21, 113, 185, 0.4);
}
.history-toggle-wrapper .btn-history-toggle.active {
  background: linear-gradient(135deg, #0d5a9c, #1571b9);
}

.right-sidebar {
  position: fixed;
  top: 0;
  right: -285px;
  width: 285px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  z-index: 1000;
}
@media screen and (max-width: 767px) {
  .right-sidebar {
    width: 100%;
    max-width: 100%;
    right: -100%;
  }
}
.right-sidebar.open {
  right: 0;
}
@media screen and (max-width: 767px) {
  .right-sidebar.open {
    right: 0;
  }
}
.right-sidebar .history-header {
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-sidebar .history-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.right-sidebar .close-btn {
  top: 0.5rem;
  right: 0.5rem;
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  color: #333;
  padding: 0;
  margin: 0;
}
.right-sidebar .close-btn:hover {
  color: #1571b9;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
}
@media screen and (max-width: 767px) {
  .right-sidebar .close-btn {
    font-size: 20px;
    width: 28px;
    height: 28px;
    top: 0.5rem;
    right: 0.5rem;
  }
}
.right-sidebar .tab-content {
  padding: 10px 0;
}
.right-sidebar .tab-content .tab-view {
  width: 100%;
}
.right-sidebar .tab-content .tab-view .left-box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.right-sidebar .tab-content .tab-view .menu-options.searchBox-pad {
  background: #c2eefb !important;
  padding: 10px;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left {
  width: 100%;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box {
  width: 100%;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field {
  width: 100%;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field .control {
  width: 100%;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field .control .input {
  width: 100%;
  border: 1px solid #81c2fb;
  border-radius: 100px;
  padding: 0.5rem 2.5rem 0.5rem 2.5rem;
  background: #fff !important;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field .has-icons-left .icon.is-left {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field .has-icons-right .icon.is-right {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
}
.right-sidebar .tab-content .tab-view .menu-options .level-left .level-item.input-search-box .field .has-icons-right .icon.is-right:hover {
  color: #1571b9;
}
.right-sidebar .tab-content .tab-view .listing-data {
  height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding-bottom: 1.5em;
  padding-left: 0.5rem;
}
.right-sidebar .tab-content .tab-view .listing-data ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.right-sidebar .tab-content .tab-view .listing-data ul li {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  border-bottom: 1px solid #eee !important;
  color: #000 !important;
  width: 100%;
}
.right-sidebar .tab-content .tab-view .listing-data ul li:hover {
  background-color: rgba(21, 113, 185, 0.1607843137);
  color: #1571b9;
}
.right-sidebar .tab-content .tab-view .listing-data .history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
}
.right-sidebar .tab-content .tab-view .listing-data .history-loading .spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #d1d5db;
  border-top: 3px solid #1571b9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}
.right-sidebar .tab-content .tab-view .listing-data .history-loading p {
  color: #6b7280;
  font-size: 0.9rem;
}
.right-sidebar .tab-content .tab-view .listing-data .history-empty {
  text-align: center;
  padding: 3rem 1.5rem;
  color: #6b7280;
}
.right-sidebar .tab-content .tab-view .listing-data .history-empty p {
  font-size: 0.9rem;
  margin: 0;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #eee;
  width: 100%;
  min-height: 45px;
}
.history-item.odd {
  background-color: #f9f9f9;
}
.history-item .history-label {
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px;
  margin: 0;
}
.history-item .history-label i {
  line-height: 1;
  margin-right: 8px;
  color: #1571b9;
  flex-shrink: 0;
}
.history-item .history-delete {
  color: #c10909 !important;
  cursor: pointer;
  padding: 10px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.history-item .history-delete .pi-trash {
  color: #c10909 !important;
}
.history-item .history-delete:hover {
  opacity: 0.8;
}

.history-section {
  width: 100%;
  padding: 1.5rem;
  background: #f9fafb;
  margin-bottom: 1rem;
}
.history-section .history-container {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}
.history-section .history-container .history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #1571b9, #00a3ff);
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.history-section .history-container .history-header .history-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.history-section .history-container .history-header .history-title i {
  font-size: 1.3rem;
}
.history-section .history-container .history-header .history-title h4 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.history-section .history-container .history-header .btn-close-history {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.history-section .history-container .history-header .btn-close-history:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}
.history-section .history-container .history-header .btn-close-history i {
  font-size: 1rem;
}
.history-section .history-container .history-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  /* Custom Scrollbar */
}
.history-section .history-container .history-content::-webkit-scrollbar {
  width: 6px;
}
.history-section .history-container .history-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.history-section .history-container .history-content::-webkit-scrollbar-thumb {
  background-color: #9ca3af;
  border-radius: 8px;
}
.history-section .history-container .history-content::-webkit-scrollbar-thumb:hover {
  background-color: #6b7280;
}
.history-section .history-container .history-content .history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
}
.history-section .history-container .history-content .history-loading .spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #d1d5db;
  border-top: 3px solid #1571b9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}
.history-section .history-container .history-content .history-loading p {
  color: #6b7280;
  font-size: 0.9rem;
}
.history-section .history-container .history-content .history-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.history-section .history-container .history-content .history-list .history-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.history-section .history-container .history-content .history-list .history-item:hover {
  background: #f3f4f6;
  border-color: #1571b9;
  box-shadow: 0 2px 8px rgba(21, 113, 185, 0.1);
  transform: translateX(4px);
}
.history-section .history-container .history-content .history-list .history-item .history-item-main {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 0;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #1571b9, #00a3ff);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-icon i {
  font-size: 1.5rem;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details {
  flex: 1;
  min-width: 0;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 150px;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name .history-status {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name .history-status i {
  font-size: 0.7rem;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name .history-status.status-completed {
  background: #d1fae5;
  color: #065f46;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name .history-status.status-processing {
  background: #fef3c7;
  color: #92400e;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-file-name .history-status.status-failed {
  background: #fee2e2;
  color: #991b1b;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.85rem;
  color: #6b7280;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta span i {
  font-size: 0.8rem;
  color: #9ca3af;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta .history-class {
  color: #1571b9;
  font-weight: 500;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta .history-date {
  color: #6b7280;
}
.history-section .history-container .history-content .history-list .history-item .history-item-main .history-details .history-meta .history-sheets {
  color: #059669;
  font-weight: 500;
}
.history-section .history-container .history-content .history-list .history-item .history-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action i {
  font-size: 0.9rem;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-view {
  background: #eff6ff;
  color: #1571b9;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-view:hover {
  background: #dbeafe;
  transform: translateY(-1px);
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-download {
  background: #f0fdf4;
  color: #059669;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-download:hover {
  background: #dcfce7;
  transform: translateY(-1px);
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-delete {
  background: #fef2f2;
  color: #dc2626;
  padding: 0.5rem;
}
.history-section .history-container .history-content .history-list .history-item .history-actions .btn-history-action.btn-delete:hover {
  background: #fee2e2;
  transform: translateY(-1px);
}
.history-section .history-container .history-content .history-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #6b7280;
}
.history-section .history-container .history-content .history-empty i {
  font-size: 3rem;
  color: #d1d5db;
  margin-bottom: 1rem;
  display: block;
}
.history-section .history-container .history-content .history-empty p {
  font-size: 1rem;
  font-weight: 500;
  margin: 0.5rem 0;
  color: #374151;
}
.history-section .history-container .history-content .history-empty small {
  font-size: 0.85rem;
  color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/app/components/excelqueandans/excel-upload/excel-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,iCAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;AACE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;AACJ;AACI;EACE,qBAAA;EACA,6CAAA;AACN;AAEI;EACE,qBAAA;EACA,6CAAA;AAAN;AAIE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AAFJ;AAKE;EACE,cAAA;EACA,sBAAA;AAHJ;AAKI;EACE,cAAA;AAHN;AAQE;EACE,kBAAA;EACA,yBAAA;EACA,0CAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,mBAAA;EACA,0BAAA;AAPJ;AASI;EACE,yBAAA;EACA,cAAA;AAPN;AAUI;EACE,yBAAA;EACA,WAAA;AARN;AAaE;EACE,cAAA;AAXJ;;AAgBA;EACE,OAAA;EACA,gBAAA;EAEA,0BAAA;AAdF;AAeE;EACE,UAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,kBAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAjBJ;AAmBI;EACE,eAAA;AAjBN;AAoBI;EACE,mBAAA;EACA,aAAA;AAlBN;AAqBI;EACE,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAnBN;AAqBM;EACE,0CAAA;AAnBR;AAsBM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AApBR;AAsBQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AApBV;AAsBU;EACE,iBAAA;EACA,cAAA;AApBZ;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAvBR;AAyBQ;EACE,OAAA;EACA,eAAA;EACA,kBAAA;AAvBV;AA4BQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AA1BV;AA4BU;EACE,mBAAA;EACA,qBAAA;AA1BZ;AA6BU;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AA3BZ;AA+BY;EACE,gBAAA;EACA,cAAA;AA7Bd;AAgCY;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AA9Bd;;AA2CA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAxCF;AA0CE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAxCJ;AA0CI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;AAxCN;AA0CM;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAxCR;AA4CQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA1CV;AA4CU;EACE,aAAA;AA1CZ;AA6CU;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA3CZ;AA6CY;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AA3Cd;AA+CU;EACE,mBAAA;EACA,qBAAA;AA7CZ;AA+CY;EACE,UAAA;AA7Cd;AAiDU;EACE,cAAA;EACA,kBAAA;AA/CZ;AAqDI;EACE,OAAA;EACA,gBAAA;EACA,qBAAA;EAEA,0BAAA;AApDN;AAqDM;EACE,UAAA;AAnDR;AAsDM;EACE,mBAAA;EACA,kBAAA;AApDR;AAuDM;EACE,yBAAA;EACA,kBAAA;AArDR;AAuDQ;EACE,yBAAA;AArDV;AAyDM;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAvDR;AAyDQ;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AAvDV;AAyDU;EACE,2BAAA;EACA,yCAAA;AAvDZ;AA0DU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAxDZ;AA0DY;EACE,aAAA;AAxDd;AA2DY;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzDd;AA2Dc;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AAzDhB;AA6DY;EACE,UAAA;AA3Dd;AA+DU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA7DZ;AA+DY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA7Dd;AAiEU;EACE,kBAAA;EACA,kBAAA;AA/DZ;AAiEY;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AA/Dd;AAkEY;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AAhEd;AAmEY;EACE,iBAAA;EACA,cAAA;AAjEd;AAqEU;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAnEZ;AAyEI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAvEN;AA0EI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAxEN;AA0EM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAxER;;AA8EA,sBAAA;AACA;EACE;IACE,uBAAA;EA3EF;EA8EA;IACE,yBAAA;EA5EF;AACF;AAkFE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gCAAA;AAhFJ;AAkFI;EACE,0CAAA;AAhFN;AAoFE;EACE,mBAAA;AAlFJ;AAqFE;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAnFJ;AAqFI;EACE,mBAAA;EACA,qBAAA;AAnFN;AAsFI;EACE,mBAAA;AApFN;AAuFI;EACE,gBAAA;EACA,WAAA;AArFN;AAuFM;EACE,cAAA;AArFR;AAyFI;;EAEE,kBAAA;EACA,kBAAA;AAvFN;AAyFM;;EACE,qBAAA;EACA,kDAAA;AAtFR;AA0FI;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;AAxFN;AA2FI;EACE,iBAAA;EACA,kBAAA;EACA,sCAAA;AAzFN;AA2FM;EACE,iBAAA;AAzFR;AA4FM;EACE,yBAAA;EACA,cAAA;AA1FR;AA+FE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AA7FJ;AA+FI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;AA7FN;AA+FM;EACE,iBAAA;EACA,sBAAA;AA7FR;AAgGM;EACE,yBAAA;EACA,2BAAA;AA9FR;;AAoGA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AAjGF;AAmGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAjGJ;AAoGE;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,yBAAA;AAlGJ;AAoGI;EACE,yCAAA;AAlGN;AAqGI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,WAAA;EACA,eAAA;AAnGN;AAqGM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAnGR;AAqGQ;EACE,iBAAA;AAnGV;AAsGQ;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;AApGV;AAyGQ;EACE,eAAA;EACA,+BAAA;AAvGV;AAyGU;EACE,aAAA;AAvGZ;AA6GQ;EACE,aAAA;AA3GV;AA8GQ;EACE,eAAA;AA5GV;AAiHI;EACE,oBAAA;EACA,mBAAA;EACA,6BAAA;AA/GN;AAiHM;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AA/GR;AAiHQ;EACE,mBAAA;AA/GV;AAkHQ;EACE,gBAAA;EACA,WAAA;AAhHV;AAmHQ;EACE,WAAA;EACA,kBAAA;AAjHV;AAuHE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AArHJ;AAuHI;EACE,iBAAA;EACA,qBAAA;AArHN;AAyHE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAvHJ;AA0HI;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qDAAA;AAxHN;AA0HM;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AAxHR;AA0HQ;EACE,mBAAA;EACA,2BAAA;AAxHV;AA4HM;EACE,8EAAA;EACA,WAAA;AA1HR;AA4HQ;EACE,sBAAA;AA1HV;AA6HQ;EACE,8EAAA;EACA,2BAAA;AA3HV;;AAmIA;EACE,iCAAA;AAhIF;;AAueA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AApeF;AAseE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,8CAAA;EACA,yBAAA;EACA,YAAA;AApeJ;AAseI;EACE,iBAAA;AApeN;AAueI;EACE,2BAAA;EACA,8CAAA;AAreN;AAweI;EACE,qDAAA;AAteN;;AA4eA;EACE,eAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,0CAAA;EACA,2BAAA;EACA,aAAA;AAzeF;AA2eE;EAXF;IAYI,WAAA;IACA,eAAA;IACA,YAAA;EAxeF;AACF;AA0eE;EACE,QAAA;AAxeJ;AA0eI;EAHF;IAII,QAAA;EAveJ;AACF;AAyeA;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAveF;AAweE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAteJ;AAyeE;EAEE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAxeJ;AA0eI;EACE,cAAA;EACA,qCAAA;EACA,kBAAA;AAxeN;AA2eI;EA1BF;IA2BI,eAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;EAxeJ;AACF;AA2eE;EACE,eAAA;AAzeJ;AA2eI;EACE,WAAA;AAzeN;AA2eM;EACE,iDAAA;AAzeR;AA6eQ;EACE,8BAAA;EACA,aAAA;AA3eV;AA8eQ;EACE,WAAA;AA5eV;AA+eY;EACE,WAAA;AA7ed;AA+ec;EACE,WAAA;AA7ehB;AA+egB;EACE,WAAA;AA7elB;AA+ekB;EACE,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,oCAAA;EACA,2BAAA;AA7epB;AAkfkB;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAhfpB;AAqfkB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;AAnfpB;AAqfoB;EACE,cAAA;AAnftB;AA6fM;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AA3fR;AA6fQ;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3fV;AA6fU;EACE,aAAA;EACA,wBAAA;EACA,oBAAA;EACA,wCAAA;EACA,sBAAA;EACA,WAAA;AA3fZ;AA6fY;EACE,kDAAA;EACA,cAAA;AA3fd;AAggBQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA9fV;AAggBU;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AA9fZ;AAigBU;EACE,cAAA;EACA,iBAAA;AA/fZ;AAmgBQ;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;AAjgBV;AAmgBU;EACE,iBAAA;EACA,SAAA;AAjgBZ;;AA0gBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AAvgBF;AAygBE;EACE,yBAAA;AAvgBJ;AA0gBE;EACE,eAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AAxgBJ;AA0gBI;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAxgBN;AA4gBE;EACE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA1gBJ;AA4gBI;EACE,yBAAA;AA1gBN;AA6gBI;EACE,YAAA;AA3gBN;;AAihBA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AA9gBF;AAghBE;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA9gBJ;AAghBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,WAAA;EACA,iDAAA;AA9gBN;AAghBM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA9gBR;AAghBQ;EACE,iBAAA;AA9gBV;AAihBQ;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AA/gBV;AAmhBM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAjhBR;AAmhBQ;EACE,oCAAA;EACA,wBAAA;AAjhBV;AAohBQ;EACE,eAAA;AAlhBV;AAuhBI;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EAEA,qBAAA;AAthBN;AAuhBM;EACE,UAAA;AArhBR;AAwhBM;EACE,mBAAA;EACA,kBAAA;AAthBR;AAyhBM;EACE,yBAAA;EACA,kBAAA;AAvhBR;AAyhBQ;EACE,yBAAA;AAvhBV;AA2hBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAzhBR;AA2hBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAzhBV;AA4hBQ;EACE,cAAA;EACA,iBAAA;AA1hBV;AA8hBM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA5hBR;AA8hBQ;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA5hBV;AA8hBU;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;EACA,0BAAA;AA5hBZ;AA+hBU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AA7hBZ;AA+hBY;EACE,WAAA;EACA,YAAA;EACA,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AA7hBd;AA+hBc;EACE,iBAAA;AA7hBhB;AAiiBY;EACE,OAAA;EACA,YAAA;AA/hBd;AAiiBc;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AA/hBhB;AAiiBgB;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;AA/hBlB;AAkiBgB;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAhiBlB;AAkiBkB;EACE,iBAAA;AAhiBpB;AAmiBkB;EACE,mBAAA;EACA,cAAA;AAjiBpB;AAoiBkB;EACE,mBAAA;EACA,cAAA;AAliBpB;AAqiBkB;EACE,mBAAA;EACA,cAAA;AAniBpB;AAwiBc;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAtiBhB;AAwiBgB;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAtiBlB;AAwiBkB;EACE,iBAAA;EACA,cAAA;AAtiBpB;AA0iBgB;EACE,cAAA;EACA,gBAAA;AAxiBlB;AA2iBgB;EACE,cAAA;AAziBlB;AA4iBgB;EACE,cAAA;EACA,gBAAA;AA1iBlB;AAgjBU;EACE,aAAA;EACA,WAAA;EACA,cAAA;AA9iBZ;AAgjBY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA9iBd;AAgjBc;EACE,iBAAA;AA9iBhB;AAijBc;EACE,mBAAA;EACA,cAAA;AA/iBhB;AAijBgB;EACE,mBAAA;EACA,2BAAA;AA/iBlB;AAmjBc;EACE,mBAAA;EACA,cAAA;AAjjBhB;AAmjBgB;EACE,mBAAA;EACA,2BAAA;AAjjBlB;AAqjBc;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAnjBhB;AAqjBgB;EACE,mBAAA;EACA,2BAAA;AAnjBlB;AA2jBM;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAzjBR;AA2jBQ;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAzjBV;AA4jBQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA1jBV;AA6jBQ;EACE,kBAAA;EACA,cAAA;AA3jBV","sourcesContent":[":host {\n  flex-direction: column;\n  background-color: #fff !important;\n  height: calc(100vh - 10px);\n}\n\n.class-dropdown {\n  width: 100%;\n  max-width: 350px;\n\n  ::ng-deep .p-dropdown {\n    background-color: #f9f9fb;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    padding: 4px 8px;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      border-color: #3b82f6; // blue-500\n      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n    }\n\n    &.p-focus {\n      border-color: #1571b9; // blue-600\n      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n    }\n  }\n\n  ::ng-deep .p-dropdown-label {\n    font-size: 14px;\n    color: #111827;\n    padding: 8px 10px;\n    text-transform: capitalize;\n  }\n\n  ::ng-deep .p-dropdown-trigger {\n    color: #6b7280; // gray-500\n    transition: color 0.2s;\n\n    &:hover {\n      color: #1571b9; // blue-600\n    }\n  }\n\n  // Dropdown panel customization\n  ::ng-deep .p-dropdown-panel {\n    border-radius: 8px;\n    border: 1px solid #d1d5db;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);\n  }\n\n  ::ng-deep .p-dropdown-item {\n    font-size: 14px;\n    padding: 8px 12px;\n    color: #111827;\n    transition: background-color 0.2s;\n    text-align: justify;\n    text-transform: capitalize;\n\n    &:hover {\n      background-color: #e0f2fe; // light blue\n      color: #1571b9;\n    }\n\n    &.p-highlight {\n      background-color: #1571b9;\n      color: #fff;\n    }\n  }\n\n  // Placeholder styling\n  ::ng-deep .p-dropdown-label.p-placeholder {\n    color: #9ca3af; // gray-400\n  }\n}\n\n\n.excelFileUpload-section {\n  flex: 1;\n  overflow-y: auto;\n\n  /* Custom Thin Scrollbar */\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #9ca3af;\n    border-radius: 8px;\n\n    &:hover {\n      background-color: #6b7280;\n    }\n  }\n\n  .elibrary-upload-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n\n    .pi {\n      font-size: 4rem;\n    }\n\n    li {\n      text-align: justify;\n      padding: 10px;\n    }\n\n    .upload-card {\n      background: #ffffff;\n      border-radius: 1rem;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n      padding: 2rem 2.5rem;\n      width: 100%;\n      max-width: 600px;\n      transition: all 0.3s ease;\n\n      &:hover {\n        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n      }\n\n      .upload-header {\n        display: flex;\n        align-items: center;\n        margin-bottom: 1.5rem;\n\n        h3 {\n          font-size: 1.4rem;\n          color: #1571b9;\n          font-weight: 600;\n\n          i {\n            margin-right: 8px;\n            color: #1571b9;\n          }\n        }\n      }\n\n      .upload-controls {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 1rem;\n\n        .class-dropdown {\n          flex: 1;\n          min-width: 100%;\n          text-align: center;\n\n\n        }\n\n        .file-upload-section {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: #f1f5f9;\n          border: 2px dashed #93c5fd;\n          border-radius: 1rem;\n          padding: 1rem 1.5rem;\n          cursor: pointer;\n          transition: 0.3s;\n          text-align: center;\n          flex-direction: column;\n          width: 100%;\n\n          &:hover {\n            background: #eff6ff;\n            border-color: #1571b9;\n          }\n\n          .upload-icon {\n            font-size: 1.8rem;\n            color: #1571b9;\n            margin-bottom: 0.5rem;\n          }\n\n          .upload-text {\n            span {\n              font-weight: 600;\n              color: #1e3a8a;\n            }\n\n            small {\n              display: block;\n              font-size: 0.8rem;\n              color: #64748b;\n            }\n          }\n        }\n      }\n    }\n  }\n\n\n\n\n}\n\n.document-list-section {\n  width: 100%;\n  padding: 1rem;\n  background: #f9fafb;\n\n  .document-container {\n    background: #fff;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    height: 75vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    .document-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 1rem;\n      border-bottom: 1px solid #e5e7eb;\n      padding-bottom: 0.8rem;\n\n      h4 {\n        font-weight: 600;\n        font-size: 1.2rem;\n        color: #1f2937;\n      }\n\n      .selection-bar {\n        .checkbox-group {\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n\n          input {\n            display: none;\n          }\n\n          .custom-checkbox {\n            width: 18px;\n            height: 18px;\n            border: 2px solid #6b7280;\n            border-radius: 4px;\n            margin-right: 8px;\n            position: relative;\n            transition: 0.2s;\n\n            &::after {\n              content: \"\";\n              position: absolute;\n              top: 2px;\n              left: 5px;\n              width: 4px;\n              height: 9px;\n              border: solid #fff;\n              border-width: 0 2px 2px 0;\n              transform: rotate(45deg);\n              opacity: 0;\n            }\n          }\n\n          input:checked+.custom-checkbox {\n            background: #1571b9;\n            border-color: #1571b9;\n\n            &::after {\n              opacity: 1;\n            }\n          }\n\n          .label-text {\n            color: #374151;\n            font-size: 0.95rem;\n          }\n        }\n      }\n    }\n\n    .library-tile-view {\n      flex: 1;\n      overflow-y: auto;\n      padding-right: 0.5rem;\n\n      /* Custom Thin Scrollbar */\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 8px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: #9ca3af;\n        border-radius: 8px;\n\n        &:hover {\n          background-color: #6b7280;\n        }\n      }\n\n      .document-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n        gap: 1rem;\n\n        .document-card {\n          background: #ffffff;\n          border-radius: 10px;\n          padding: 0.8rem;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n          position: relative;\n          cursor: pointer;\n          transition: all 0.25s ease-in-out;\n\n          &:hover {\n            transform: translateY(-3px);\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n          }\n\n          .checkbox-overlay {\n            position: absolute;\n            top: 10px;\n            right: 10px;\n\n            input {\n              display: none;\n            }\n\n            .custom-checkbox {\n              width: 25px;\n              height: 25px;\n              border: 2px solid #9ca3af;\n              border-radius: 4px;\n              background: #fff;\n              position: relative;\n\n              &::after {\n                content: \"\";\n                position: absolute;\n                top: 0px;\n                left: 7px;\n                width: 7px;\n                height: 18px;\n                border: solid #1571b9;\n                border-width: 0 2px 2px 0;\n                transform: rotate(45deg);\n                opacity: 0;\n              }\n            }\n\n            input:checked+.custom-checkbox::after {\n              opacity: 1;\n            }\n          }\n\n          .document-thumbnail {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            img {\n              width: 60px;\n              height: 60px;\n              object-fit: contain;\n            }\n          }\n\n          .document-info {\n            margin-top: 0.5rem;\n            text-align: center;\n\n            .title {\n              font-size: 0.95rem;\n              font-weight: 600;\n              color: #1f2937;\n            }\n\n            .shared-by {\n              font-size: 0.85rem;\n              color: #6b7280;\n              margin: 2px 0;\n            }\n\n            .views {\n              font-size: 0.8rem;\n              color: #9ca3af;\n            }\n          }\n\n          .document-footer {\n            text-align: center;\n            font-size: 0.75rem;\n            color: #6b7280;\n            margin-top: 0.5rem;\n          }\n        }\n      }\n    }\n\n    .empty-state {\n      text-align: center;\n      color: #6b7280;\n      padding: 2rem 0;\n    }\n\n    .loading-state {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      height: 60vh;\n\n      .spinner {\n        width: 30px;\n        height: 30px;\n        border: 3px solid #d1d5db;\n        border-top: 3px solid #1571b9;\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n        margin-bottom: 10px;\n      }\n    }\n  }\n}\n\n/* Spinner Animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n.sheet-form-list {\n  .sheet-form-container {\n    background: #fff;\n    padding: 1.5rem;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    transition: box-shadow 0.3s ease;\n\n    &:hover {\n      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n    }\n  }\n\n  .sheet-list {\n    margin-bottom: 2rem;\n  }\n\n  .sheet-item {\n    background: #fafafa;\n    border: 1px solid #eee;\n    border-radius: 10px;\n    padding: 1rem;\n    margin-bottom: 1rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: #f5f9ff;\n      border-color: #cce0ff;\n    }\n\n    .field {\n      margin-bottom: 1rem;\n    }\n\n    .label {\n      font-weight: 600;\n      color: #333;\n\n      .required {\n        color: #ff3860;\n      }\n    }\n\n    .input,\n    .select select {\n      border-radius: 6px;\n      border-color: #ddd;\n\n      &:focus {\n        border-color: #1571b9;\n        box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);\n      }\n    }\n\n    .remove-btn-wrapper {\n      display: flex;\n      align-items: flex-end;\n      justify-content: center;\n      height: 80%;\n    }\n\n    .remove-btn {\n      font-size: 0.9rem;\n      border-radius: 6px;\n      transition: background-color 0.2s ease;\n\n      i {\n        margin-right: 6px;\n      }\n\n      &:hover {\n        background-color: #ffe6e6;\n        color: #d32f2f;\n      }\n    }\n  }\n\n  .form-footer {\n    display: flex;\n    justify-content: center;\n    margin-top: 1.5rem;\n\n    .submit-btn {\n      border-radius: 8px;\n      font-weight: 600;\n      padding: 0.75rem 2rem;\n      background-color: #1571b9;\n      color: #fff;\n      transition: all 0.3s ease;\n\n      i {\n        margin-right: 8px;\n        color: #fff !important;\n      }\n\n      &:hover {\n        background-color: #1571b9;\n        transform: translateY(-1px);\n      }\n    }\n  }\n}\n\n.sheet-form-list {\n  padding: 1.5rem;\n  background: #f8f9fa;\n  border-radius: 16px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n\n  .data-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n  }\n\n  .sheet-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    transition: all 0.3s ease;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    .sheet-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 1rem 1.2rem;\n      background: linear-gradient(135deg, #1571b9, #00a3ff);\n      color: #fff;\n      cursor: pointer;\n\n      .sheet-title {\n        display: flex;\n        align-items: center;\n        gap: 0.6rem;\n\n        .icon {\n          font-size: 1.2rem;\n        }\n\n        .sheet-name {\n          font-weight: 600;\n          font-size: 1.05rem;\n          text-transform: capitalize;\n        }\n      }\n\n      .sheet-actions {\n        .icon-toggle {\n          font-size: 1rem;\n          transition: transform 0.3s ease;\n\n          &.up {\n            display: none;\n          }\n        }\n      }\n\n      &.active {\n        .icon-toggle.down {\n          display: none;\n        }\n\n        .icon-toggle.up {\n          display: inline;\n        }\n      }\n    }\n\n    .sheet-body {\n      padding: 1rem 1.5rem;\n      background: #fafafa;\n      border-top: 1px solid #e5e5e5;\n\n      .qa-item {\n        margin-bottom: 0.8rem;\n        padding: 0.8rem;\n        border-radius: 8px;\n        background: #ffffff;\n        transition: background 0.2s ease;\n\n        &.has-question:hover {\n          background: #f0f8ff;\n        }\n\n        .question {\n          font-weight: 600;\n          color: #333;\n        }\n\n        .answer {\n          color: #555;\n          margin-top: 0.3rem;\n        }\n      }\n    }\n  }\n\n  .no-data {\n    text-align: center;\n    color: #777;\n    padding: 2rem;\n\n    i {\n      font-size: 1.5rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n\n  .action-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: 2rem;\n\n\n    .btn {\n      border: none;\n      border-radius: 8px;\n      padding: 0.6rem 1.2rem;\n      font-weight: 500;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n      transition: background 0.3s ease, transform 0.2s ease;\n\n      &-close {\n        background: #e0e0e0;\n        color: #333;\n        width: 60px;\n        padding: 14px;\n\n        &:hover {\n          background: #d6d6d6;\n          transform: translateY(-2px);\n        }\n      }\n\n      &-download {\n        background: linear-gradient(135deg, #1571b9, #1572b9d9);\n        color: #fff;\n\n        i{\n          color: #fff !important;\n        }\n\n        &:hover {\n          background: linear-gradient(135deg, #1571b9, #1572b9d9);\n          transform: translateY(-2px);\n        }\n      }\n    }\n  }\n}\n\n\n::ng-deep .file-cta {\n  background-color: #fff !important;\n}\n\n// .container-fluid{\n//     background: #fff !important;\n// }\n// .field-label{\n//     flex-grow:3;\n// }\n\n// .sheet-form-list{\n//     max-height:85vh;\n//     overflow-y: auto;\n//   //  background-color: #fff;\n//     font-size: .9rem;\n//     color: #111;\n//     scrollbar-width:thin;\n//     .data-content{\n//         width:95%;\n//         margin:auto;\n//     }\n// }\n\n// ::-webkit-scrollbar{\n//     scrollbar-width: 0px;\n// }\n\n// .field {\n//     .label{\n//         font-size:.9rem;\n//     }\n// }\n// .btn-submit{\n//     background: #eee;\n//     color: #666;\n//     font-size: .9rem;\n//     font-weight: bold;\n//     padding: 5px 20px;\n//     box-shadow: 1px 1px 3px #666;\n// }\n// .btn-remove{\n//     border: none;\n//     .fa-trash::before {\n//        color: #ff1d32;\n//     }\n// }\n// .btn-dowload{\n//     background: #eeeeee;\n//     color: #666;\n//     font-size: .9rem;\n//     font-weight: bold;\n//     padding: 5px 20px;\n//     box-shadow: 1px 1px 3px #666;\n//     border: none;\n// }\n\n// .border-row{\n//     border-bottom:1px solid #d8d8d8;\n//     padding:5px;\n// }\n// .table-heading{\n//     background-color: #eee;\n//     border-bottom:1px solid #666;\n//     padding:5px;\n// }\n\n// .data-content{\n//     background:#fff;\n//     padding:10px;\n// }\n// ::ng-deep .p-dropdown {\n//     min-width: 15rem;\n//     width: 90px !important;\n//     border: 1px solid #dcdcdc;\n//     padding: 5px;\n//     border-radius: 5px;\n//     color:#111;\n\n//     .p-dropdown-items{\n//       background: #fff;\n//       border:1px solid #dcdcdc;\n\n//       border-radius: 5px;\n\n//       li{\n//         padding:5px;\n//         color:#111;\n//         span{\n//           text-transform: capitalize;\n//         }\n//       }\n//        li:hover{\n//           background: #f4f4f4 !important;\n//           color: #171717;\n//         }\n\n//         li[aria-selected=\"true\"]{\n//           background: #eee !important;\n//         }\n//     }\n\n\n// }\n\n// .file-upload-wrapper{\n//     display: flex;\n//     color:#fff;\n//     flex-direction: column;\n// }\n\n// .qa-container {\n//   position: relative;\n//    background: #ddd;\n//   padding: 10px;\n//   display: flex;\n//   margin:8px 8px 0px;\n//   flex-direction: column;\n//  // border:1px solid #38a8fb;\n//  color: #111;\n//   //border-radius:10px;\n//   font-size:.9rem;\n//   cursor: pointer;\n//   width:100%;\n//   box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n//   b{\n//     font-size:.92rem !important;\n//   }\n//   .qa-wrapper {\n//     margin-left: 5px\n//   }\n//   .expand-icon{\n//      position: absolute;\n//      top:10px;\n//      right:10px;\n//     span{\n//       .fa-solid{\n//         font-size:1.5rem;\n//         color:#111 !important;\n//       }\n//     }\n//   }\n//   .expand-icon{\n//     .up{\n//       display: none;\n//     }\n//   }\n// }\n// .qa-container.expand {\n\n\n//    .expand-icon{\n//     .up{\n//           display: block;\n//         }\n//      .down{\n//       display: none;\n//      }   \n//     }\n\n// }\n// .qa-email-container {\n//   position: relative;\n//    background: #fff;\n//    color: #5a5757;\n//   padding: 10px;\n//   display:none;\n//   width:100%;\n//    margin-left:8px;\n//   flex-direction: column;\n//   // border:1px solid #c1c2c3;\n//   font-size:.9rem;\n//   //border-radius:10px;\n//   box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n//   .qa-wrapper {\n//     margin-left: 5px\n//   }\n// }\n\n// .qa-email-container.is-active{\n//   display: flex;\n// }\n\n// // E-library tile view styles\n// .library_tile_view {\n//   padding: 0px 0px 7px 0px !important;\n\n//   .drag-drop-container .card {\n//     height: 140px !important;\n\n//     .dropdown-content {\n//       padding: 0px !important;\n//       .dropdown-item:hover {\n//         background-color: #e7e7e7 !important;\n//       }\n//       .dropdown-divider {\n//         margin: 0px !important;\n//       }\n//     }\n//     .tools {\n//       margin-top: 5px !important;\n//     }\n//   }\n\n//   .flex-container {\n//     .flex-item {\n//       .card {\n//         .title {\n//           margin-bottom: .2rem;\n//           width: 100%;\n//         }\n//         .title, .shared {\n//           cursor: pointer;\n//         }\n//         .title, label {\n//           font-size: .9rem;\n//         }\n//         .shared, .subtitle {\n//           color: #a1a1a1;\n//         }\n//         &:hover {\n//           cursor: pointer;\n//           .fileBtnOptions {\n//             display: block !important;\n//           }\n//         }\n\n//         .card-image {\n//           height: 100px !important;\n//           .thumb_play {\n//             position: absolute;\n//             top: 48%;\n//             left: 45%;\n//             display: none;\n\n//             .fa {\n//               color: #dcdcdc;\n//               font-size: 32px !important;\n//             }\n//           }\n//           .lesson_image {\n//             padding: 5px;\n//           }\n//           .tile_imgcenter {\n//             height: auto;\n//             display: block;\n//             width: 80%;\n//             padding: 10px;\n//           }\n//         }\n\n//         .card-content, .card-body {\n//           padding: 0.75rem;\n//         }\n\n//         .card-footer {\n//           padding: 0.5rem 0.75rem;\n//           border-top: 1px solid #dbdbdb;\n//         }\n//       }\n//     }\n//   }\n\n//   .card-image {\n//     .checkbox-wrapper {\n//       position: absolute;\n//       z-index: 1;\n//       top: 2px;\n//       right: 2px;\n//     }\n//   }\n\n//   // Checkbox styling - matching e-library-tile\n//   .checkbox-wrapper {\n//     box-sizing: border-box;\n//     --background-color: #fff;\n//     --checkbox-height: 20px;\n//   }\n\n//   .checkbox-wrapper input[type=checkbox] {\n//     display: none;\n//   }\n\n//   .checkbox-wrapper .check-box {\n//     height: var(--checkbox-height);\n//     width: var(--checkbox-height);\n//     background-color: transparent;\n//     border: calc(var(--checkbox-height) * .1) solid #858585;\n//     border-radius: 5px;\n//     position: relative;\n//     display: inline-block;\n//     box-sizing: border-box;\n//     transition: border-color ease 0.2s;\n//     cursor: pointer;\n//   }\n\n//   .checkbox-wrapper .check-box::before,\n//   .checkbox-wrapper .check-box::after {\n//     box-sizing: border-box;\n//     position: absolute;\n//     height: 0;\n//     width: calc(var(--checkbox-height) * .2);\n//     background-color: #34b93d;\n//     display: inline-block;\n//     transform-origin: left top;\n//     border-radius: 5px;\n//     content: \" \";\n//     transition: opacity ease 0.5;\n//   }\n\n//   .checkbox-wrapper .check-box::before {\n//     top: calc(var(--checkbox-height) * .72);\n//     left: calc(var(--checkbox-height) * .41);\n//     box-shadow: 0 0 0 calc(var(--checkbox-height) * .05) var(--background-color);\n//     transform: rotate(-135deg);\n//   }\n\n//   .checkbox-wrapper .check-box::after {\n//     top: calc(var(--checkbox-height) * .37);\n//     left: calc(var(--checkbox-height) * .05);\n//     transform: rotate(-45deg);\n//   }\n\n//   .checkbox-wrapper input[type=checkbox]:checked + .check-box {\n//     border-color: #34b93d;\n//   }\n\n//   .checkbox-wrapper input[type=checkbox]:checked + .check-box::after {\n//     height: calc(var(--checkbox-height) / 2);\n//     animation: dothabottomcheck-19 0.2s ease 0s forwards;\n//   }\n\n//   .checkbox-wrapper input[type=checkbox]:checked + .check-box::before {\n//     height: calc(var(--checkbox-height) * 1.2);\n//     animation: dothatopcheck-19 0.4s ease 0s forwards;\n//   }\n\n//   @keyframes dothabottomcheck-19 {\n//     0% {\n//       height: 0;\n//     }\n//     100% {\n//       height: calc(var(--checkbox-height) / 2);\n//     }\n//   }\n\n//   @keyframes dothatopcheck-19 {\n//     0% {\n//       height: 0;\n//     }\n//     50% {\n//       height: 0;\n//     }\n//     100% {\n//       height: calc(var(--checkbox-height) * 1.2);\n//     }\n//   }\n// }\n\n// History Sidebar Styles\n.history-toggle-wrapper {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  z-index: 100;\n\n  .btn-history-toggle {\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #1571b9, #00a3ff);\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    font-weight: 600;\n    font-size: 1.2rem;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(21, 113, 185, 0.3);\n    transition: all 0.3s ease;\n    z-index: 100;\n\n    i {\n      font-size: 1.2rem;\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 18px rgba(21, 113, 185, 0.4);\n    }\n\n    &.active {\n      background: linear-gradient(135deg, #0d5a9c, #1571b9);\n    }\n  }\n}\n\n// Right Sidebar (matching ai-assist component structure)\n.right-sidebar {\n  position: fixed;\n  top: 0;\n  right: -285px;\n  width: 285px;\n  height: 100%;\n  background: #fff;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);\n  transition: right 0.3s ease;\n  z-index: 1000;\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    max-width: 100%;\n    right: -100%;\n  }\n\n  &.open {\n    right: 0;\n\n    @media screen and (max-width: 767px) {\n      right: 0;\n    }\n  }\n.history-header{\n  padding: 5px 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  h4{\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n  .close-btn {\n    // position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 1;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1001;\n    color: #333;\n    padding: 0;\n    margin: 0;\n\n    &:hover {\n      color: #1571b9;\n      background-color: rgba(0, 0, 0, 0.05);\n      border-radius: 50%;\n    }\n\n    @media screen and (max-width: 767px) {\n      font-size: 20px;\n      width: 28px;\n      height: 28px;\n      top: 0.5rem;\n      right: 0.5rem;\n    }\n  }\n\n  .tab-content {\n    padding: 10px 0;\n\n    .tab-view {\n      width: 100%;\n\n      .left-box-shadow {\n        box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;\n      }\n\n      .menu-options {\n        &.searchBox-pad {\n          background: #c2eefb !important;\n          padding: 10px;\n        }\n\n        .level-left {\n          width: 100%;\n\n          .level-item {\n            &.input-search-box {\n              width: 100%;\n\n              .field {\n                width: 100%;\n\n                .control {\n                  width: 100%;\n\n                  .input {\n                    width: 100%;\n                    border: 1px solid #81c2fb;\n                    border-radius: 100px;\n                    padding: 0.5rem 2.5rem 0.5rem 2.5rem;\n                    background: #fff !important;\n                  }\n                }\n\n                .has-icons-left {\n                  .icon.is-left {\n                    position: absolute;\n                    left: 12px;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    color: #666;\n                  }\n                }\n\n                .has-icons-right {\n                  .icon.is-right {\n                    position: absolute;\n                    right: 12px;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    color: #666;\n                    cursor: pointer;\n\n                    &:hover {\n                      color: #1571b9;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .listing-data {\n        height: 90vh;\n        overflow-y: auto;\n        background: #fff;\n        padding-bottom: 1.5em;\n        padding-left: 0.5rem;\n\n        ul {\n          margin: 10px 0px;\n          padding: 0px 10px;\n          list-style: none;\n          display: flex;\n          flex-direction: column;\n          line-height: 1.2rem;\n\n          li {\n            display: flex;\n            justify-content: stretch;\n            align-items: stretch;\n            border-bottom: 1px solid #eee !important;\n            color: #000 !important;\n            width: 100%;\n\n            &:hover {\n              background-color: #1571b929;\n              color: #1571b9;\n            }\n          }\n        }\n\n        .history-loading {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          padding: 3rem 0;\n\n          .spinner {\n            width: 30px;\n            height: 30px;\n            border: 3px solid #d1d5db;\n            border-top: 3px solid #1571b9;\n            border-radius: 50%;\n            animation: spin 1s linear infinite;\n            margin-bottom: 10px;\n          }\n\n          p {\n            color: #6b7280;\n            font-size: 0.9rem;\n          }\n        }\n\n        .history-empty {\n          text-align: center;\n          padding: 3rem 1.5rem;\n          color: #6b7280;\n\n          p {\n            font-size: 0.9rem;\n            margin: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n// History item styles (matching ai-assist component)\n.history-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0;\n  border-bottom: 1px solid #eee;\n  width: 100%;\n  min-height: 45px;\n\n  &.odd {\n    background-color: #f9f9f9;\n  }\n\n  .history-label {\n    cursor: pointer;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 0.9rem;\n    min-height: 25px;\n    padding: 10px;\n    margin: 0;\n\n    i {\n      line-height: 1;\n      margin-right: 8px;\n      color: #1571b9;\n      flex-shrink: 0;\n    }\n  }\n\n  .history-delete {\n    color: #c10909 !important;\n    cursor: pointer;\n    padding: 10px;\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    .pi-trash {\n      color: #c10909 !important;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n// Legacy history-section styles (keeping for backward compatibility)\n.history-section {\n  width: 100%;\n  padding: 1.5rem;\n  background: #f9fafb;\n  margin-bottom: 1rem;\n\n  .history-container {\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    max-height: 70vh;\n    display: flex;\n    flex-direction: column;\n\n    .history-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 1.25rem 1.5rem;\n      background: linear-gradient(135deg, #1571b9, #00a3ff);\n      color: #fff;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n      .history-title {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n\n        i {\n          font-size: 1.3rem;\n        }\n\n        h4 {\n          margin: 0;\n          font-size: 1.25rem;\n          font-weight: 600;\n        }\n      }\n\n      .btn-close-history {\n        background: rgba(255, 255, 255, 0.2);\n        border: none;\n        color: #fff;\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: rgba(255, 255, 255, 0.3);\n          transform: rotate(90deg);\n        }\n\n        i {\n          font-size: 1rem;\n        }\n      }\n    }\n\n    .history-content {\n      flex: 1;\n      overflow-y: auto;\n      padding: 1rem;\n\n      /* Custom Scrollbar */\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 8px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: #9ca3af;\n        border-radius: 8px;\n\n        &:hover {\n          background-color: #6b7280;\n        }\n      }\n\n      .history-loading {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding: 3rem 0;\n\n        .spinner {\n          width: 30px;\n          height: 30px;\n          border: 3px solid #d1d5db;\n          border-top: 3px solid #1571b9;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n          margin-bottom: 10px;\n        }\n\n        p {\n          color: #6b7280;\n          font-size: 0.9rem;\n        }\n      }\n\n      .history-list {\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n\n        .history-item {\n          background: #f9fafb;\n          border: 1px solid #e5e7eb;\n          border-radius: 12px;\n          padding: 1rem;\n          transition: all 0.3s ease;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          gap: 1rem;\n\n          &:hover {\n            background: #f3f4f6;\n            border-color: #1571b9;\n            box-shadow: 0 2px 8px rgba(21, 113, 185, 0.1);\n            transform: translateX(4px);\n          }\n\n          .history-item-main {\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n            flex: 1;\n            min-width: 0;\n\n            .history-icon {\n              width: 48px;\n              height: 48px;\n              background: linear-gradient(135deg, #1571b9, #00a3ff);\n              border-radius: 10px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              color: #fff;\n              flex-shrink: 0;\n\n              i {\n                font-size: 1.5rem;\n              }\n            }\n\n            .history-details {\n              flex: 1;\n              min-width: 0;\n\n              .history-file-name {\n                display: flex;\n                align-items: center;\n                gap: 0.75rem;\n                margin-bottom: 0.5rem;\n                flex-wrap: wrap;\n\n                h5 {\n                  margin: 0;\n                  font-size: 1rem;\n                  font-weight: 600;\n                  color: #1f2937;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                  white-space: nowrap;\n                  flex: 1;\n                  min-width: 150px;\n                }\n\n                .history-status {\n                  display: inline-flex;\n                  align-items: center;\n                  gap: 0.25rem;\n                  padding: 0.25rem 0.75rem;\n                  border-radius: 20px;\n                  font-size: 0.75rem;\n                  font-weight: 600;\n                  text-transform: uppercase;\n                  letter-spacing: 0.5px;\n\n                  i {\n                    font-size: 0.7rem;\n                  }\n\n                  &.status-completed {\n                    background: #d1fae5;\n                    color: #065f46;\n                  }\n\n                  &.status-processing {\n                    background: #fef3c7;\n                    color: #92400e;\n                  }\n\n                  &.status-failed {\n                    background: #fee2e2;\n                    color: #991b1b;\n                  }\n                }\n              }\n\n              .history-meta {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 1rem;\n                font-size: 0.85rem;\n                color: #6b7280;\n\n                span {\n                  display: inline-flex;\n                  align-items: center;\n                  gap: 0.4rem;\n\n                  i {\n                    font-size: 0.8rem;\n                    color: #9ca3af;\n                  }\n                }\n\n                .history-class {\n                  color: #1571b9;\n                  font-weight: 500;\n                }\n\n                .history-date {\n                  color: #6b7280;\n                }\n\n                .history-sheets {\n                  color: #059669;\n                  font-weight: 500;\n                }\n              }\n            }\n          }\n\n          .history-actions {\n            display: flex;\n            gap: 0.5rem;\n            flex-shrink: 0;\n\n            .btn-history-action {\n              display: flex;\n              align-items: center;\n              gap: 0.4rem;\n              padding: 0.5rem 0.75rem;\n              border: none;\n              border-radius: 8px;\n              font-size: 0.85rem;\n              font-weight: 500;\n              cursor: pointer;\n              transition: all 0.2s ease;\n              white-space: nowrap;\n\n              i {\n                font-size: 0.9rem;\n              }\n\n              &.btn-view {\n                background: #eff6ff;\n                color: #1571b9;\n\n                &:hover {\n                  background: #dbeafe;\n                  transform: translateY(-1px);\n                }\n              }\n\n              &.btn-download {\n                background: #f0fdf4;\n                color: #059669;\n\n                &:hover {\n                  background: #dcfce7;\n                  transform: translateY(-1px);\n                }\n              }\n\n              &.btn-delete {\n                background: #fef2f2;\n                color: #dc2626;\n                padding: 0.5rem;\n\n                &:hover {\n                  background: #fee2e2;\n                  transform: translateY(-1px);\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .history-empty {\n        text-align: center;\n        padding: 3rem 1rem;\n        color: #6b7280;\n\n        i {\n          font-size: 3rem;\n          color: #d1d5db;\n          margin-bottom: 1rem;\n          display: block;\n        }\n\n        p {\n          font-size: 1rem;\n          font-weight: 500;\n          margin: 0.5rem 0;\n          color: #374151;\n        }\n\n        small {\n          font-size: 0.85rem;\n          color: #9ca3af;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
